import React, { useEffect, useState } from "react";
import { fetchCustomerDetails, redeemService } from "../../api";
import Pagination from "../../components/Pagination/Pagination";
import "./CustomerPurchaseList.css";

const FreeStringingServices = () => {
  const [purchases, setPurchases] = useState([]);
  const [redeemedServices, setRedeemedServices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Authentication token not found.");
        const response = await fetchCustomerDetails(token);
        setPurchases(response.data.purchases);
      } catch (error) {
        console.error("Error fetching purchases:", error);
      }
    };
    fetchPurchases();
  }, []);

  const handleRedeem = async (invoiceNo, productSku) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Authentication token not found.");
      await redeemService(token, invoiceNo, productSku);
      setRedeemedServices((prev) => [...prev, { invoiceNo, productSku }]);
    } catch (error) {
      console.error("Error redeeming service:", error);
    }
  };

  const freeServices = purchases.filter(
    (purchase) => purchase.product_sku === "Stringing Service"
  );

  const totalPages = Math.ceil(freeServices.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const displayedPurchases = freeServices.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (page) => setCurrentPage(page);

  return (
    <div className="purchase-list-container">
      <div className="section-header">
        <h2>Free Stringing Services</h2>
        <p className="service-message">
          You have {freeServices.length} free stringing services left.
        </p>
      </div>

      {freeServices.length === 0 ? (
        <p>No free stringing services available.</p>
      ) : (
        <>
          <table className="purchase-table">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Purchase Date</th>
                <th>Valid Until</th>
                <th>Status</th>
                <th>Services</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {displayedPurchases.map((service, index) => (
                <tr key={`${service.invoice_no}-${index}`}>
                  <td>{service.invoice_no}</td>
                  <td>
                    {new Date(service.purchase_date).toLocaleDateString(
                      "en-GB",
                      {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      }
                    )}
                  </td>
                  <td>
                    {new Date(service.valid_until).toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </td>
                  <td>{service.status}</td>
                  <td>{service.product_sku}</td>
                  <td>
                    {redeemedServices.some(
                      (redeemed) =>
                        redeemed.invoiceNo === service.invoice_no &&
                        redeemed.productSku === service.product_sku
                    ) ? (
                      "Redeemed"
                    ) : (
                      <button
                        className="redeem-button"
                        onClick={() =>
                          handleRedeem(service.invoice_no, service.product_sku)
                        }
                      >
                        Redeem
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </div>
  );
};

export default FreeStringingServices;
